"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APGrid = void 0;
var react_1 = __importDefault(require("react"));
function APGrid(props) {
    var _a, _b;
    var gridGap = props.spacing ? props.spacing + "px" : props.gapProps;
    var mStyle = {
        display: "grid", width: "100%",
        gridGap: gridGap !== null && gridGap !== void 0 ? gridGap : ((_a = props.rowGap) !== null && _a !== void 0 ? _a : 0) + " " + ((_b = props.columnGap) !== null && _b !== void 0 ? _b : 0),
        gridTemplateColumns: "repeat(" + props.count + ",minmax(0,1fr))",
    };
    return (react_1.default.createElement("div", { style: mStyle }, react_1.default.Children.map(props.children, function (child) {
        if (child)
            return react_1.default.cloneElement(child, { style: { maxWidth: "100%" } });
    })));
}
exports.APGrid = APGrid;
